import { IApplicationState } from '../../types/store';

export function selectSelectedRegion(state: IApplicationState) {
  return state.geo.selectedRegion;
}
